import { useState } from "react";

const ERROR_MESSAGE = "Please, confirm the box above";

export function useCheckboxValidator() {
  const [checked, setChecked] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const validateCheckbox = () => {
    setErrorMessage(checked ? "" : ERROR_MESSAGE);
    return checked;
  };
  return { checked, setChecked, validateCheckbox, errorMessage };
}
